import DonateCard from "./components/Donate_Card/DonateCard";
const App = () => {
  return (
    <div className="app">
      {/* If you want to test different components just place here the main file of that component here from the components folder e.g. <BlogCard/> */}
      <DonateCard />
    </div>
  );
};

export default App;
